import { useUserContext } from '../../providers/UserProvider';

function Greeting(): JSX.Element {
    const { firstName } = useUserContext();

    return (
        <section className="grid gap-y-2">
            <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-200">Hi, {firstName}!</h1>
            {/* <div className="flex text-sm text-gray-600 dark:text-gray-300 flex-wrap">
                <p>Would you like to continue working on &nbsp;</p>
                <p className="text-indigo-600">2023 EOFY Compliance &nbsp;</p>
                <p>for &nbsp;</p>
                <p className="font-medium">Bartley Technologies</p>
                <p>?</p>
            </div> */}
        </section>
    );
}

export default Greeting;
